import React, { ReactElement } from 'react'

import { ArrowRightIcon } from '@hm-group/fabric-icons'
import { CTALink, HeadingMedium, HeadingLarge } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'

import { ACCOUNT_ROUTES } from 'App/constants'

import styles from '../MyRewardsList.scss'

const renderHeading = (heading: string, isNorthstarBrand: boolean, trackViewAllCTA): ReactElement =>
  isNorthstarBrand ? (
    <div className={styles.viewAllHeading}>
      <HeadingLarge>{heading}</HeadingLarge>
      <CTALink ctaLink to={ACCOUNT_ROUTES.AllRewardsList.path} onClick={trackViewAllCTA}>
        <ArrowRightIcon className={styles.viewAllArrowIcon} size="medium" />
      </CTALink>
    </div>
  ) : (
    <div className={styles.viewAllButton}>
      <HeadingMedium>{heading}</HeadingMedium>
      <CTALink ctaLink to={ACCOUNT_ROUTES.AllRewardsList.path}>
        {getLabelFromStorage('account.view.all')}
      </CTALink>
    </div>
  )

export default renderHeading
